import { Form, Space, Spin } from 'antd'
import CIMSButton from 'components/CIMSButton'
import CIMSFormItem from 'components/CIMSFormItem'
import {
  DefaultMutationHookOptions,
  DefaultQueryHookOptions,
} from 'utils/defaults'
import { useCreateWorkflowMutation, useGetWorkflowsProjectsQuery } from 'schema'
import { useOptions } from 'components/CIMSSelect/hooks/useOptions'
import CIMSSelect from 'components/CIMSSelect'
import { useForm, useWatch } from 'antd/lib/form/Form'
import TechnicalDirectionsFormItems from './components/TechnicalDirectionsFormItems'
import { WorkflowsFormValues } from './types'
import { simpleCreateNotification } from 'hooks/notificationHandler'

const Workflows: React.VFC = () => {
  const [form] = useForm()
  const template = useWatch('template', form)
  const [create] = useCreateWorkflowMutation({
    ...DefaultMutationHookOptions,
    onCompleted: ({
      createWorkflow: {
        created: { label },
      },
    }) => simpleCreateNotification(label),
  })
  const { data, refetch, loading } = useGetWorkflowsProjectsQuery({
    ...DefaultQueryHookOptions,
    variables: {
      input: {
        active: true,
        deleted: false,
        projectName: {
          null: false,
        },
      },
    },
  })
  const projectOptions = useOptions({
    items: data?.projects?.records,
    label: 'projectName',
    value: 'globalId',
    sort: 'projectName',
  })
  return (
    <Form
      form={form}
      onFinish={async (input: WorkflowsFormValues) => {
        await create({
          variables: {
            input,
          },
        })
        refetch()
      }}
    >
      <Spin spinning={loading}>
        <Space style={{ width: '600px' }} size={'middle'} direction="vertical">
          <CIMSFormItem
            name="projectId"
            label="Project"
            requiredMessage="Please select a project"
            help="The Project the Workflow will be associated with"
          >
            <CIMSSelect simple options={projectOptions} />
          </CIMSFormItem>
          <CIMSFormItem
            name="template"
            label="Template"
            requiredMessage="Please select a template"
            help="A pre-determined set of fields, status, and configurations for a particular workflow"
          >
            <CIMSSelect
              simple
              options={[
                {
                  label: 'Technical Directions',
                  value: 'Technical Directions',
                },
              ]}
            />
          </CIMSFormItem>
          {template === 'Technical Directions' && (
            <TechnicalDirectionsFormItems />
          )}
          <CIMSButton type="primary" htmlType="submit">
            Create {template ?? 'Workflow'}
          </CIMSButton>
        </Space>
      </Spin>
    </Form>
  )
}

export default Workflows
